export const apiEndpoints = {
  companyList: `api/Companies`,
  userBuyerList: `api/User/buyers`,
  purchasingCodeList: `api/PurchasingCode`,
  userPnaSearch: `api/PnaRequest/UserPnaSearch`,
  userItem: `api/PnaRequest/AddItemWithAttachment`,
  updateUserItem: `api/PnaRequest/UpdateItemWithAttachment`,
  uomList: `api/PnaRequest/uom`,
  prioritylist: `api/PnaRequest/priority`,
  userSelectLoadQa: `api/PnaRequest/userSelectLoadQa`,
  otherPnaSearch: `api/PnaRequest/OtherUserPnaSearch`,
  withdraw: `api/PnaRequest/withdraw`,
  deleteItem: `api/PnaRequest/deleteItem`,
  pnadeleterequest: `api/PnaRequest/delete`,
  LocationList: `api/Location`,
  userSelectLoadEmail: `api/Graph/GenerateUserInfoAll?cond=`,
  downloadDocument: `api/Home/DownloadDocument`,
  userItemList: `api/PnaRequest/LoadItem`,
  getItemDetails: `api/PnaRequest/GetItemDetails`,
  deleteAttachment: `api/PnaRequest/DeleteDoc`,
  getAttachmentsDetails: `api/PnaRequest/GetDocAttachments`,
  adminMangeSearch: `api/Admin/adminMangeSearch`,
  getpna: `api/PnaRequest/getPna`,
  activeBuyersList: `api/PnaSearch/activeBuyersList`,
  updatePnaRequest: `api/Admin/updatePnaRequest`,
  reportLocationList: `api/Report/locationList`,
  reportPurchasingList: `api/Report/purchasingList`,
  reportBuyerList: `api/Report/buyerList`,
  reportOwnerList: `api/Report/ownerList`,
  reportCCNList: `api/Report/ccnList`,
  detailsReportList: `api/Report/detailsReportList`,
  exportDetailsReport: `api/Report/exportDetailsReport`,
  searchDelegations: `api/delegation/search`,
  delegationDelete: `api/delegation/delete`,
  delegationSave: `api/delegation/save`,
  getDelegation: `api/delegation/getdelegates`,
  reportCycleList: `api/Report/reportCycleList`,
  exportCycleExcelReport: `api/Report/exportCycleExcelReport`,
  itemDetailsReportList: `api/Report/itemDetailsReportList`,
  exportItemDetailsExcelReport: `api/Report/exportItemDetailsExcelReport`,
  OtherBuyerPnaSearch: `api/Buyers/OtherBuyerPnaSearch`,
  OtherLeadBuyerPnaSearch: `api/LeadBuyers/OtherBuyerPnaSearch`,
  checkAdminAccess: `api/user/userInfo`,
  manageAdminUserList: `api/admin/users`,
  pnaRequestgetCcnBranch: `api/PnaRequest/getCcnBranch`,
  pnaRequestSaveEdit: `api/PnaRequest/save-edit`,
  pnaRequestSave: `api/PnaRequest/save`,
  CreatePnaIdTemp: `api/PnaRequest/CreatePnaIdTemp`,
  searchUserByEmail: `api/Graph/search-user`,
  getAssignedPNARequests: `api/Buyers/getAssignedPNARequests`,
  getAssignedLeadBuyerPNARequests: `api/LeadBuyers/getAssignedLeadBuyerPNARequests`,
  pnaRequestLeadBuyerAction: `api/LeadBuyers/pnaRequestLeadBuyerAction`,
  pnaRequestBuyerAction: `api/Buyers/pnaRequestBuyerAction`,
  buyerRemoveAttachment: `/api/Buyers/BuyerRemoveAttachment`,

  //buyerPnaSearch: `api/PnaRequest/BuyerPnaSearch`,
  //BuyerpurchasingCodeList: `api/BuyerPurchasingCode`,
  //buyercheckAttachment: `api/PnaRequest/buyercheckattachment`,
  //getBuyerpna: `api/PnaRequest/getBuyerPna`,
  //adminMangeList: `api/AdminPnaSearch/adminMangeList`,
  //pnaRequestGetPna: `api/PnaRequest/getPna`,
  //buyerPnaRequest: `api/PnaRequest`,
  //otherBuyerPnaRequestLoadList: `api/Buyers/OtherBuyerPnaRequestList`,
  //checkDelegation: `api/delegation/check`,
  //checkAttachment: `api/PnaRequest/checkattachment`,
  //otherPnaRequestList: `api/PnaRequest/OtherPnaRequestList`,
  //loadItemNo: `api/PnaRequest/loadItemNo`,
};
